import api from './api';

const tenantService = {
  getTenants: async () => {
    const response = await api.get('/tenants');
    return response.data;
  },

  selectTenant: async (tenantId) => {
    const response = await api.post('/tenants/select', { tenantId });
    return response.data;
  }
};

export default tenantService;